// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCHfJrDf5ZGu2QhofQ8NrOJp7RJ6Hnlp_E",
  authDomain: "diaporamacollaboratif.firebaseapp.com",
  projectId: "diaporamacollaboratif",
  storageBucket: "diaporamacollaboratif.firebasestorage.app",
  messagingSenderId: "55252161757",
  appId: "1:55252161757:web:a4889388cfad7c7b60b734",
  measurementId: "G-JDK36G6B38"
};

// Initialise Firebase
const app = initializeApp(firebaseConfig);

// Exporte les services dont on aura besoin ailleurs dans l'appli
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);